import { ReactNode, useEffect, useState } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { supabase } from '../../../lib/supabase';

export function AuthGuard() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    // Check initial auth state
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      console.log('Current auth state:', session ? 'Authenticated' : 'Not authenticated');
      console.log('Current route:', location.pathname);
      setIsAuthenticated(!!session);
      
      if (!session) {
        console.log('No session found, redirecting to login');
        navigate('/auth/login');
      }
    };
    
    checkAuth();
  }, [navigate, location]);

  useEffect(() => {
    console.log('Setting up auth listener');
    const { data: authListener } = supabase.auth.onAuthStateChange((event, session) => {
      console.log('Auth state changed:', event, 'Session:', !!session);
      setIsAuthenticated(!!session);
      
      if (!session) {
        console.log('Session ended, redirecting to login');
        navigate('/auth/login');
      }
    });

    return () => {
      console.log('Cleaning up auth listener');
      authListener.subscription.unsubscribe();
    };
  }, [navigate]);

  if (!isAuthenticated) {
    console.log('Not authenticated, rendering nothing');
    return null;
  }

  console.log('Authenticated, rendering protected content');
  return <Outlet />;
}